export enum RoofingType {
  ArchitecturalShingles = 'architectural-shingles',
  AsphaltShingles = 'asphalt-shingles',
  EconomyMetal = 'economy-metal',
  Metal = 'metal',
  StandardMetal = 'standard-metal',
}
